/*
 * One colour and label per application/claim status, shared by badges and status tabs.
 * Keys are normalised (upper case, spaces to underscores), so "Under review",
 * "UNDER REVIEW" and "UNDER_REVIEW" all resolve to the same entry.
 */
export const STATUS_CONFIG = {
  PENDING: { label: "Pending", color: "#FFB800" },
  RECEIVED: { label: "Received", color: "#60A5FA" },
  RECEIVED_BY_HEC: { label: "Received by HEC", color: "#60A5FA" },
  RECEIVED_BY_UNIVERSITY: { label: "Received by University", color: "#60A5FA" },
  RECEIVED_BY_PARTNER: { label: "Received by Partner", color: "#60A5FA" },
  ASSIGNED_FOR_REVIEW: { label: "Assigned for Review", color: "#8B5CF6" },
  UNDER_REVIEW: { label: "Under Review", color: "#8B5CF6" },
  IN_PROGRESS: { label: "In Progress", color: "#8B5CF6" },
  SUBMITTED_TO_UNIVERSITY: { label: "Submitted to University", color: "#7C3AED" },
  SUBMITTED_TO_PARTENER: { label: "Submitted to Partner", color: "#7C3AED" },
  VERIFIED: { label: "Verified", color: "#10B981" },
  APPROVED: { label: "Approved", color: "#10B981" },
  GRANTED: { label: "Granted", color: "#1DB954" },
  COMPLETED: { label: "Completed", color: "#10B981" },
  RETURNED: { label: "Returned", color: "#F59E0B" },
  NOT_GRANTED: { label: "Not Granted", color: "#EF4444" },
  REJECTED: { label: "Rejected", color: "#EF4444" },
};

const FALLBACK_COLOR = "#94A3B8";

export const normaliseStatus = (status) =>
  String(status ?? "").trim().toUpperCase().replace(/[\s-]+/g, "_");

const humanise = (key) =>
  key.toLowerCase().replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());

// Unknown statuses still render, in neutral slate, with a readable label
export const getStatusConfig = (status) => {
  const key = normaliseStatus(status);
  return STATUS_CONFIG[key] ?? { label: humanise(key) || "Unknown", color: FALLBACK_COLOR };
};
